export default __webpack_public_path__ + "static/cert-icon-09-958bbe456b6bc9c1ff8f6e45de8fa516.png";